/* ====================================
   Shop by Look — Ketch Theme
   Hotspot interactions + Bulk Add
   ==================================== */

/* ── Component 1: Hotspot ↔ Product Card scroll + highlight ── */

class ShopByLookHotspots {
  constructor(container) {
    this.container = container;
    this.hotspots = container.querySelectorAll('.shop-by-look__hotspot');
    this.productItems = container.querySelectorAll('.shop-by-look__product-item');
    this.productList = container.querySelector('.shop-by-look__product-list');
  }

  init() {
    if (!this.hotspots.length || !this.productItems.length) return;
    this.hotspots.forEach(function (hotspot) {
      hotspot.addEventListener('click', this.handleHotspotClick.bind(this));
    }.bind(this));
  }

  handleHotspotClick(event) {
    var index = parseInt(event.currentTarget.dataset.productIndex, 10);
    var targetCard = this.productItems[index];
    if (!targetCard || !this.productList) return;

    var containerRect = this.productList.getBoundingClientRect();
    var cardRect = targetCard.getBoundingClientRect();
    var scrollOffset =
      cardRect.left - containerRect.left - containerRect.width / 2 + cardRect.width / 2;
    this.productList.scrollBy({ left: scrollOffset, behavior: 'smooth' });

    this.hotspots.forEach(function (h) {
      h.classList.remove('active');
    });
    event.currentTarget.classList.add('active');

    this.highlightCard(targetCard);
  }

  highlightCard(card) {
    this.productItems.forEach(function (item) {
      item.classList.remove('highlighted');
    });
    card.classList.add('highlighted');
    setTimeout(function () {
      card.classList.remove('highlighted');
    }, 2000);
  }
}

/* ── Component 2: Variant selector updates data-variant-id ── */

function initVariantSelectors(container) {
  var selects = container.querySelectorAll('[data-variant-select]');
  selects.forEach(function (select) {
    select.addEventListener('change', function (event) {
      var card = event.target.closest('.stl-card');
      if (card) card.dataset.variantId = event.target.value;
    });
  });
}

/* ── Component 3: Bulk Add Button ── */

function initBulkAddButton(container) {
  var btn = container.querySelector('.shop-by-look__bulk-btn');
  if (!btn || btn.dataset.bound) return;
  btn.dataset.bound = 'true';

  btn.addEventListener('click', function () {
    if (btn.getAttribute('aria-disabled') === 'true') return;

    var cards = container.querySelectorAll('.stl-card[data-variant-id]');
    var items = [];
    cards.forEach(function (card) {
      var vid = card.dataset.variantId;
      var listItem = card.closest('[data-bundle-excluded]');
      if (vid && !listItem) items.push({ id: parseInt(vid, 10), quantity: 1 });
    });

    if (!items.length) return;

    btn.classList.add('loading');
    btn.setAttribute('aria-disabled', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () {
        if (window.KetchCartDrawer) {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cartData) {
              window.KetchCartDrawer.refreshWithData(cartData);
              document.dispatchEvent(new CustomEvent('cart:update'));
            });
        } else {
          document.dispatchEvent(new CustomEvent('cart:update'));
        }

        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
      })
      .catch(function (err) {
        console.error('Shop by Look bulk add error:', err);
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
      });
  });
}

/* ── Initialization ── */

function initShopByLook() {
  document.querySelectorAll('.shop-by-look').forEach(function (section) {
    var hotspotHandler = new ShopByLookHotspots(section);
    hotspotHandler.init();
    initVariantSelectors(section);
    initBulkAddButton(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initShopByLook);
} else {
  initShopByLook();
}

// Shopify theme editor support
document.addEventListener('shopify:section:load', function (event) {
  if (event.target.querySelector('.shop-by-look')) initShopByLook();
});
